export const STANDARD_COLORS = {
  Used: '#1FC16B',
  Expired: '#FB3748',
  Canceled: '#F6B51E',
  Rescheduled: '#97DCFF',
  Scheduled: '#335CFF',
  Rejected: '#ede52f',
  All: '#CACFD8',
};

export const STATUS_BAR_COLORS = {
  Used: {
    backgroundColor: '#C2F5DA',
    borderColor: '#1FC16B',
  },
  Expired: {
    backgroundColor: '#FFC0C5',
    borderColor: '#FB3748',
  },
  Canceled: {
    backgroundColor: '#FFDD81',
    borderColor: '#FFAD00',
  },
  Rescheduled: {
    backgroundColor: '#C0EAFF',
    borderColor: '#47C2FF',
  },
  Scheduled: {
    backgroundColor: '#C0D5FF',
    borderColor: '#335CFF',
  },
  Rejected: {
    backgroundColor: '#ede52f',
    borderColor: '#FFAD00',
  },
};

export const ORIGIN_SOURCE_COLORS = {
  All: '#CACFD8',
  Manual: '#335CFF',
  External: '#717784',
  Autobook: '#1FC16B',
};

export const TERMINAL_COLORS = {
  All: '#CACFD8',
  Trapac: '#6366F1', // Indigo
  Matson: '#8B5CF6', // Purple
  'SSA Marine': '#EC4899', // Pink
  Everport: '#F59E0B', // Amber
  Yusen: '#10B981', // Emerald
};

/**
 * Get color for chart datasets and legend items based on split view
 * @param {string} label - The label to get color for
 * @param {string} splitView - Current split view ('status', 'originSource', 'terminal')
 * @returns {string} Hex color code
 */
export const getChartColor = (label, splitView) => {
  if (splitView === 'status') {
    return STANDARD_COLORS[label] || STANDARD_COLORS.All;
  }

  if (splitView === 'originSource') {
    return ORIGIN_SOURCE_COLORS[label] || ORIGIN_SOURCE_COLORS.All;
  }

  if (splitView === 'terminal') {
    return TERMINAL_COLORS[label] || TERMINAL_COLORS.All;
  }

  return STANDARD_COLORS.All;
};
